export function positionDropdown() {
  document.querySelectorAll('.custom-dropdown').forEach(function (dropdown) {
    var selected = dropdown.querySelector('.custom-dropdown__selected');
    var list = dropdown.querySelector('.custom-dropdown__list');
    var options = dropdown.querySelectorAll('.custom-dropdown__option');
    var hiddenInput = dropdown.querySelector('input[type="hidden"]');
    var qtyInput = dropdown.closest('.product-inputs').querySelector('.product-inputs__qty-input');
    var initialOption = Array.from(options).find(function (opt) {
      return opt.dataset.value === hiddenInput.value;
    });
    if (initialOption) selected.textContent = initialOption.textContent;
    selected.addEventListener('click', function (e) {
      var productItem = e.target.closest('.collectionPLP-products-item');
      if (list.style.display !== 'block') {
        productItem.classList.add('overflow-hidden');
        list.style.display = 'block';
      } else {
        productItem.classList.remove('overflow-hidden');
        list.style.display = 'none';
      }
      e.stopPropagation();
    });
    var productItem = dropdown.closest('.collectionPLP-products-item');
    if (productItem) {
      productItem.addEventListener('mouseleave', function () {
        productItem.classList.remove('overflow-hidden');
        list.style.display = 'none';
      });
    }
    options.forEach(function (option) {
      option.addEventListener('click', function (e) {
        options.forEach(function (opt) {
          return opt.classList.remove('active');
        });
        option.classList.add('active');
        selected.textContent = option.textContent;
        hiddenInput.value = option.dataset.value;
        list.style.display = 'none';

        // Cambia min y value según si es mini o no
        if (qtyInput) {
          var min = option.dataset.min ? parseInt(option.dataset.min, 10) : 12;
          qtyInput.min = min;
          qtyInput.value = min;
        }
        if (typeof updateStock === 'function') {
          updateStock(hiddenInput, dropdown.dataset.productId);
        }
      });
    });
    document.addEventListener('click', function () {
      list.style.display = 'none';
    });
    window.addEventListener('scroll', function () {
      if (list.style.display === 'block') positionDropdown();
    });
    window.addEventListener('resize', function () {
      if (list.style.display === 'block') positionDropdown();
    });
  });
}